import { z } from 'zod';
import { InteractionProvider } from '../index.js';
import { InteractionEventType } from './index.js';
// Link Mobility SMS Event Types
export const linkMobilityCustomParametersSchema = z.object({
    source: z.string(),
    received: z.string(),
    destination: z.string(),
});
export const LinkMobilityEventBronzeDataSchema = z.object({
    id: z.string(),
    refId: z.string(),
    operator: z.string(),
    segments: z.number(),
    timestamp: z.string(),
    resultCode: z.number(),
    sentTimestamp: z.string(),
    customParameters: linkMobilityCustomParametersSchema,
    operatorResultCode: z.union([z.string(), z.number()]).nullable(),
    gateCustomParameters: z.unknown(),
});
export const LinkMobilityInternalEventBronzeDataSchema = z.string();
export const LinkMobilityEventSchema = z.union([
    z.object({
        provider: z.literal(InteractionProvider.LinkMobility),
        bronzeData: LinkMobilityEventBronzeDataSchema,
    }),
    z.object({
        provider: z.literal(InteractionProvider.LinkMobility),
        bronzeData: LinkMobilityInternalEventBronzeDataSchema,
    }),
]);
export const mapLinkMobilityEvent = (bronzeEvent) => {
    const err = 'Response from SMS provider was not successful';
    // @ts-expect-error
    if (bronzeEvent === err) {
        return {
            provider: InteractionProvider.LinkMobility,
            type: InteractionEventType.Failed,
            data: {
                reason: err,
            },
            bronzeData: bronzeEvent,
        };
    }
    if (bronzeEvent.resultCode === 1001) {
        return {
            provider: InteractionProvider.LinkMobility,
            type: InteractionEventType.Delivered,
            data: {
                operator: bronzeEvent.operator,
            },
            bronzeData: bronzeEvent,
        };
    }
    else {
        return {
            provider: InteractionProvider.LinkMobility,
            type: InteractionEventType.Failed,
            data: {
                reason: LinkMobilityResultCode[`${bronzeEvent.resultCode}`],
            },
            bronzeData: bronzeEvent,
        };
    }
};
const LinkMobilityResultCode = {
    '0': 'Unknown error',
    '1': 'Temporary routing error',
    '2': 'Permanent routing error',
    '3': 'Maximum throttling exceeded',
    '4': 'Timeout',
    '5': 'Operator unknown error',
    '6': 'Operator error',
    '104': 'Configuration error',
    '105': 'Internal error (internal Link Mobility error)',
    '106': 'Quota Exceeded',
    '1000': 'Sent (to operator)',
    '1001': 'Billed and delivered',
    '1002': 'Expired',
    '1003': 'Deleted',
    '1004': 'Mobile full',
    '1005': 'Queued',
    '1006': 'Not delivered',
    '1007': 'Delivered, Billed delayed',
    '1008': 'Billed OK (charged OK before sending message)',
    '1009': 'Billed OK and NOT Delivered',
    '1010': 'Expired, generated by LINK',
    '1011': 'Billed OK and sent (to operator)',
    '1012': 'Delayed (temporary billing error, system will try to',
    '1013': 'Message sent to operator, Bill delayed',
    '2000': 'Invalid source, the specified source number or',
    '2001': 'Source shortnumber not supported, the source',
    '2002': 'Source alpha not supported, the source TON may',
    '2003': 'Source MSISDN not supported, the source TON',
    '2100': 'Destination shortnumber not supported, the',
    '2101': 'Destination alpha not supported, the destination',
    '2102': 'Destination MSIDN not supported, the destination',
    '2103': 'Operation blocked, requested operation is not',
    '2104': 'Unknown subscriber',
    '2105': 'Destination blocked (subscriber permanently',
    '2106': 'Number error',
    '2107': 'Destination temporarily blocked (subscriber',
    '2108': 'Invalid destination',
    '2200': 'Charging error',
    '2201': 'Subscriber has low balance',
    '2202': 'Subscriber barred for overcharged (premium)',
    '2203': 'Subscriber too young (for this particular content)',
    '2204': 'Prepaid subscriber not allowed',
    '2205': 'Service rejected by subscriber',
    '2206': 'Subscriber not registered in payment system',
    '2207': 'Subscriber has reached max balance',
    '3000': 'GSM encoding is not supported',
    '3001': 'UCS2 encoding is not supported',
    '3002': 'Binary encoding is not supported',
    '4000': 'Delivery report is not supported',
    '4001': 'Invalid message content',
    '4002': 'Invalid tariff',
    '4003': 'Invalid user data',
    '4004': 'Invalid user data header',
    '4005': 'Invalid data coding',
    '4006': 'Invalid VAT',
    '4007': 'Unsupported content for destination',
};
//# sourceMappingURL=link-mobility.js.map